<template>
  <q-dialog v-model="show">
    <q-card style="min-width: 400px; max-width: 90vw;">
      <q-card-section class="row items-center">
        <q-icon name="warning" color="negative" class="q-mr-sm" />
        <div class="text-h6">Erros encontrados</div>
      </q-card-section>

      <q-separator />

      <q-card-section>
        <div v-if="errors.length">
          <q-list bordered>
            <q-item v-for="(error, index) in errors" :key="index">
              <q-item-section>
                <q-item-label class="text-negative">
                  {{ error.message }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </div>
        <div v-else class="text-grey text-center">
          Nenhum erro para exibir.
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="right">
        <q-btn flat label="Fechar" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'ErrorDialog',
  props: {
    value: Boolean,
    errors: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
